import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import ViewDocDialoug from './ViewDocDialoug';
import { Getrequest, Putrequest } from '../../../../context/AxiosRequest';
import { ContextData } from '../../../../context/Context';
import { toast } from 'react-toastify';
import SoundAlert from '../../../../routes/SoundAlert';

export default function DocumentTable(props) {


    const { accestoken ,setGlobalLoader,GlobalLoader,UserTokens} = React.useContext(ContextData);
    const [rejectionReason, setRejectionReason] = React.useState(props.data.rejectionReason || "");

    const rejectionReasons = [
        "Correct",
        "Incomplete Document",
        "Invalid Format",
        "Expired Document",
        "Missing Information",
        "Mismatched Details",
        "Fraudulent Document",
        "Document Corruption",
        "Unclear Image",
        "Non-Compliance with Guidelines",
        "Other"
    ];

    const HandleVerify = async (type,document_type_name,user_token,email) => {

        if (type === "rejected" && !rejectionReason) {
            toast.error("Please select a rejection reason.");
              SoundAlert("error");
            return;
        }

          if (type === "rejected" && rejectionReason === rejectionReasons[0]) {
              toast.error("Please select a valid rejection reason.");
              SoundAlert("error");
            return;
        }

        if (type === "revoked" && !rejectionReason) {
            toast.error("Please select a revoked reason.");
            SoundAlert("error");
            return;
        }


        if (type === "accepted" && rejectionReason !== rejectionReasons[0]) {
              SoundAlert("error");
            toast.error("Please select 'Correct' as the reason for acceptance.");
            return;
        }

        const data = {
            type,
            file_token: props.data.file_token,
            rejectionReason,
            document_type_name,
            user_token,
            email,
            verifier_token: UserTokens
        }
         
        const response = await Putrequest(`/auth/handle_verify`,data,accestoken);

          toast.success(response);
          SoundAlert("success");
          setGlobalLoader(!GlobalLoader);
          
     
    };

    const handleReasonChange = (event) => {
        setRejectionReason(event.target.value);
    };

    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

   
             <TableCell align="center" sx={{whiteSpace:"nowrap"}}>{props.data.document_type_name} </TableCell>
              
            <TableCell align="center" sx={{whiteSpace:"nowrap"}}>

                   {
                props.data.reupload_status === "reuploaded" ?
                <Badge color="error" badgeContent={"re-uploaded"}>
                <ViewDocDialoug docname={props.data.document_type_name} from="viewdoc" filePath={props.data.document_file_name} filetoken={props.file_token} token={props.token} />
                </Badge>
                :
                <ViewDocDialoug docname={props.data.document_type_name} from="viewdoc" filePath={props.data.document_file_name} filetoken={props.file_token} token={props.token} />
                   }


            </TableCell>
            <TableCell align="center" sx={{whiteSpace:"nowrap"}}>
                <select onChange={handleReasonChange} value={rejectionReason}>
                    <option value="">Select Rejection Reason</option>
                    {rejectionReasons.map((reason, index) => (
                        <option key={index} value={reason}>
                            {reason}
                        </option>
                    ))}
                </select>
            </TableCell>
            <TableCell align="center" sx={{whiteSpace:"nowrap"}}>
                <ViewDocDialoug   from="viewrejtmsg" filePath={props.data.document_file_name}  filetoken={props.file_token} token={props.token} />
            </TableCell>

            <TableCell align="center" sx={{whiteSpace:"nowrap"}}>
                {
               props.from === "verification" && 
                <>    
                <Button disabled={props.data.verify_status === "accepted"} onClick={() => HandleVerify("rejected",props.data.document_type_name,props.data.user_token,props.email)} sx={{ background: "red" }} variant='contained'>
                    Reject
                </Button>
                <Button disabled={props.data.verify_status === "accepted"} onClick={() => HandleVerify("accepted",props.data.document_type_name,props.data.user_token,props.email)} sx={{ marginLeft: "5px" }} variant='contained'>
                    Accept
                </Button>
                <Button disabled={props.data.verify_status === "revoked" || props.data.verify_status === "rejected" || props.data.verify_status === null} onClick={() => HandleVerify("revoked",props.data.document_type_name,props.data.user_token,props.email)} sx={{ marginLeft: "5px", background: "blue" }} variant='contained'>
                    Revoke
                </Button>
                    </>
                  }

                 {
                 props.from === "loanapproval" &&  
                <Button disabled={props.data.verify_status === "revoked" || props.data.verify_status === "rejected" || props.data.verify_status === null} onClick={() => HandleVerify("revoked",props.data.document_type_name,props.data.user_token,props.email)} sx={{ marginLeft: "5px", background: "blue" }} variant='contained'>
                    Revoke
                </Button>
                 }
            </TableCell> 
        </TableRow>
    );
}
